























import Vue from 'vue';
import { MStorePopupHelper } from '@/mixins/mStorePopupHelper';

export default Vue.extend({
  name: 'ExampleCustomIndexingLookup',
  methods: {
    onClose() {
      MStorePopupHelper.methods.closeModal();
    }
  }
});
